<template>
<div>
    <smallbutton toplabel="Add Group" @click="startAdd()" v-if="showButton" :buttonclass="buttonclass"/>
    <linkbutton toplabel="Add Group" @click="startAdd()" v-if="!showButton"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Add Product Group</label>
                <br/>
                
                <div class="entry">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="locationselect">Location</label>
                    </div>
                    <select name="" id="locationselect" class='entrySelect' v-model="productGroup.locationId" required>
                        <option v-for="loc in locationList" :key="loc.id" :value="loc.id" >
                            {{loc.name}}
                        </option>
                    </select>
                </div>
                <formentry inputid="groupname"  label="Name"  v-model="productGroup.name" :isrequired="trueParam" />
                
                <div class="entry" v-if="showLibrary">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="islibrary">Is Equipment Group</label>
                    </div>
                    <input id="islibrary" v-model="productGroup.isLibrary" type="checkbox">
                </div>

                <div>
                    <label  class="required">{{requiredFieldLabel}}</label>
                </div>
                
                  <!-- image -->
                <div class="showProductImage">
                    <br>
                    <!-- Category image upload removed: POSTed to a non-existent POS route
                         (saveproductgroupimage → 404). Manage the browse-category image on the
                         Category tab (Admin → Categories) instead. -->
                </div>

                <smallbutton  @click="save()" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
                
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import imagealldoc from '../controls/ImageAll.vue'
export default {
    name:'addgroup',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        imagealldoc
    },
    props:{
        
        showButton:{
            type:Boolean,
            default:false
        },
        buttonclass:{
          type:String,
          default:"button buttonprimary"
        },
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            
            responseMessage:'',
            pleaseWait:false,
            productGroup:{
                name:'',
                locationId:0,
                isActive:true,
                id:-1,
                isLibrary:false
            },
            locationList:[],
            requiredFieldLabel:'* required',
            trueParam:true,
            falseParam:false
        }
    },
    computed:{
        ...mapFields([


        ]),
        
        showLibrary(){
            
            if(window.SHOW_LIBRARY==undefined){return false}
            else{return window.SHOW_LIBRARY}
        },
        getProductImage(){
       
                if(this.productGroup.imageFilename==null){return null}
                    var imgBasePath =  window.VUE_CONFIG_API + 'personimage/'

                var fn = this.productGroup.imageFilename
                var splitfn=fn
                const lastDot = fn.lastIndexOf('.');
                if (lastDot > 0) {
                splitfn= fn.slice(0, lastDot) + '/' + fn.slice(lastDot + 1);
                }

                    return imgBasePath + splitfn
        },
    },
    mounted(){
        this.GetLocations()
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
      
        startAdd(){
           
            this.productGroup={
                name:'',
                locationId:0,
                isActive:true,
                id:-1,
                isLibrary:false,
                imageFilename:null
            }   

            this.$refs.mymodal.openModal()
        },
        async save(){
           let req = {
                productGroup:this.productGroup
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/addproductgroup')
            //handle response
            if(response.Successful){
                this.$emit('saved')
                this.$refs.mymodal.closeModal()
                
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },

       async GetLocations(){
            
                this.beforeAPI();
                var response = await this.callAPI(null,'ecommerce/admin/locations')

                if(response.Successful){
                    this.locationList=response.locationList
                
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
           
        },
        addfile(){
            this.$refs.imgdoc.openModal() 
        },
        saveimg_document(file,url,typeId){
                    this.storeDocument("doc", file, file.name,typeId)
        },
        
        async storeDocument(filename,file, name,typeId){
            var pId=this.productGroup.id
            var postParams = new FormData();

            postParams.append(filename,file,name);
            postParams.append('productGroupId',pId);
            postParams.append('locationId',this.productGroup.locationId);
            postParams.append('name',this.productGroup.name);
            postParams.append('isLibrary',this.productGroup.isLibrary);

            this.pleaseWait=true
            var response = await this.callAPI(postParams,'saveproductgroupimage')
            //handle response
            if(response.Successful){
                //this.RefreshCurrent() 
                this.productGroup.imageFilename= response.fileName
                this.productGroup.id=response.id
            }else{
                this.responseMessage = response.Message
            }
              this.pleaseWait=false  
        },  
        
    }
}
</script>

<style>

</style>





























